import {Injectable} from '@angular/core';
import {Subject, Observable, BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private subject = new Subject<any>();

  sendMessage(message: string, params = {}, link = ''): void {
    this.subject.next({text: message, params: params, link: link});
  }

  clearMessages(): void {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
